import {ChangeDetectorRef, Component, OnDestroy, OnInit, ComponentFactoryResolver, Type, ViewChild, ViewContainerRef} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {Subject} from 'rxjs';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {select, Store} from '@ngrx/store';
import {CommandService} from '@core/services/command.service';
import {DataSurveyState} from '../../store/reducers/data-survey.reducers';
import {SnackBarService} from '@core/services/snack-bar.service';
import {takeUntil} from 'rxjs/operators';
import {getSmartGridFieldDataTypes} from '@shared/store/selectors/smart-grid.selectors';
import {GetSmartGridFieldDataTypesAction} from '@shared/store/actions/smart-grid.actions';
import {
  AddSectionCommand,
  AddSurveySectionCommand
} from '../../commands/survey.commands';
import {FieldDataTypeModel} from '@shared/models/field-data-type.model';
import {FieldDefinition} from '@shared/models/field-definition';
import { Configuration } from '@shared/models/configuration';
import { RootDynamicComponentHelper } from '@shared/helpers/root-dynamic-component-helper';
import {EditSurveyQuestionDialogModel} from '../../models/data-survey.models';
import {GetSurveyAction} from "../../store/actions/data-survey.actions";
import {getCurrentSurvey} from "../../store/selectors/data-survey.selectors";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import { MatOptionSelectionChange } from '@angular/material/core';

@Component({
    standalone: false,
    selector: 'particle-edit-question-dialog',
  templateUrl: './edit-question-dialog.component.html',
  styleUrls: ['./edit-question-dialog.component.scss']
})
export class EditQuestionDialogComponent implements OnInit, IDialogView, OnDestroy {
  // Need EditFieldQuestionDialogModel to use
  editFieldQuestionDetails: EditSurveyQuestionDialogModel;
  data: DialogModel;
  editQuestionForm: any;
  allDataTypes: any[];
  sections: any[];
  unsubscribe$ = new Subject<void>();
  survey: any;
  isQuestionSettingsChecked: boolean;
  selectedSection: any;
  questionDetails: FieldDefinition;
  options: any;
  fieldSettings: any;
  @ViewChild('dynamicComponent', {read: ViewContainerRef}) viewContainerRef;
  selectedDataType: any;
  addNewSectionInProgress: boolean;
  config: any;
  lastAddSectionHeader: string;
  ngUnsubscribe = new Subject<void>();
  invalidateSubject: InvalidateSubject;

  constructor(private formBuilder: FormBuilder,
              private particleStore: Store<ParticleState>,
              private commandService: CommandService,
              private componentFactoryResolver: ComponentFactoryResolver,
              private changeDetector: ChangeDetectorRef,
              private dataSurveyStore: Store<DataSurveyState>,
              private snackBarService: SnackBarService) {
    this.editQuestionForm = this.formBuilder.group({
      questionHeader: new FormControl('', Validators.required),
      questionTitle: new FormControl('', Validators.required),
      questionDataType: new FormControl('', Validators.required),
      questionSection: new FormControl('', Validators.required),
      isRequired: new FormControl(true, Validators.required)
    });
    this.isQuestionSettingsChecked = false;
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {
    console.log('edit question model:', this.data.input.editFieldQuestionDetails);
    this.selectedSection = this.data.input.editFieldQuestionDetails.selectedSection;
    this.questionDetails = this.data.input.editFieldQuestionDetails.questionDetails;
    this.invokeSmartGridFieldDataTypes();
    this.populateForm();
    this.particleStore.pipe(select(getSmartGridFieldDataTypes, 'Data-Survey'), takeUntil(this.unsubscribe$)).subscribe((dataTypes: any[]) => {
      this.allDataTypes = dataTypes;
      if(this.allDataTypes && this.allDataTypes.length) {
        this.allDataTypes.forEach(data => {
          let configKey = data.configKey;
          if (configKey === undefined || configKey === null) {
            configKey = '';
          }
          let dataType = data.dataType;
          if (dataType === undefined || dataType === null) {
            dataType = '';
          }
          const uniqueIdentifier = `${dataType},${configKey}`;
          data.dataTypeConfigKey = uniqueIdentifier;
        });
      }

      if (!this.editQuestionForm.control['questionDataType'].value) {
        // this.editQuestionForm.control['questionDataType'].value = this.allDataTypes[0];
        this.editQuestionForm.patchValue({['questionDataType']: this.allDataTypes[0].dataTypeConfigKey});
      }
    });

    this.dataSurveyStore.select(getCurrentSurvey).pipe(takeUntil(this.ngUnsubscribe)).subscribe(currentSurvey => {
      console.log('current survey:', currentSurvey);
      this.survey = currentSurvey;
      if (this.survey && this.survey.definitionSections) {
        this.sections = this.survey.definitionSections;
        if (this.lastAddSectionHeader) {
          const selectedSection = this.sections.find(o => o.header === this.lastAddSectionHeader);
          if (selectedSection) {
            this.editQuestionForm.patchValue({['questionSection']: selectedSection.sectionId});
            this.selectedSection = selectedSection;
          }
        }
        if (this.sections.length && this.editQuestionForm.controls['questionSection'].value === '') {
          console.log('this:', this.selectedSection);
          this.editQuestionForm.patchValue({['questionSection']: this.selectedSection ? this.selectedSection.sectionId : this.sections[0].sectionId});
          if (this.editQuestionForm.controls['questionSection'].value === this.sections[0].sectionId) {
            this.selectedSection = this.sections[0];
          }
        }
      }
    });
  }

  resetEditing() {
    this.addNewSectionInProgress = false;
  }

  showAddSection() {
    this.addNewSectionInProgress = true;
  }

  addSection($event) {
    console.log('Section Name', $event);
    if (this.survey) {
      const command = new AddSurveySectionCommand(this.survey.id, $event.text);
      this.commandService.executeCommand(command)
        .pipe(takeUntil(this.unsubscribe$)).subscribe(commandState => {
        this.getCurrentSurvey();
        this.lastAddSectionHeader = $event.text;
        this.addNewSectionInProgress = false;
      });
    }
  }

  invokeSmartGridFieldDataTypes() {
    this.particleStore.dispatch(new GetSmartGridFieldDataTypesAction('Data-Survey'));
  }

  navigateToQuestionSettings() {
    this.isQuestionSettingsChecked = true;
    this.generateSettingsEditorComponent();
  }

  onCloseQuestionSettings() {
    this.isQuestionSettingsChecked = false;
  }

  generateSettingsEditorComponent() {
    this.changeDetector.detectChanges();
    const resolvedComponent = <Type<any>>RootDynamicComponentHelper.getComponent(this.fieldSettings);
    this.viewContainerRef.clear();
    const component = this.viewContainerRef.createComponent(resolvedComponent);
    component.instance.fieldDefinition = this.questionDetails;
  }

  getCurrentSurvey() {
    this.dataSurveyStore.dispatch(new GetSurveyAction(this.survey.id));
  }

  onSectionChange($event: any) {
  }
  onSelectionChange($event: MatOptionSelectionChange, dataType: any) {
    if ($event.source.selected) {
      this.selectedDataType = JSON.parse(JSON.stringify(dataType));
      this.fieldSettings = null;
      if (this.selectedDataType.configKey) {
        const fieldConfig = Configuration.getSmartGridConfig(this.selectedDataType.configKey);
        if (fieldConfig && fieldConfig.FieldSettings) {
          this.fieldSettings = fieldConfig.FieldSettings;
        }
      }
      this.questionDetails.dataType = this.selectedDataType.dataType;
      this.questionDetails.configKey = this.selectedDataType.configKey;
      this.questionDetails.options = this.selectedDataType.options;
      this.questionDetails.options.forEach(o => o['isEditing'] = false);
    }
  }
/*  onQuestionTypeChange(event: any) {
    this.selectedDataType = this.allDataTypes.find(o => o.dataType === event.value);
    this.fieldSettings = null;
    if (this.selectedDataType.configKey) {
      const fieldConfig = Configuration.getSmartGridConfig(this.selectedDataType.configKey);
      if (fieldConfig && fieldConfig.FieldSettings) {
        this.fieldSettings = fieldConfig.FieldSettings;
      }
    }
    this.questionDetails.dataType = this.selectedDataType.dataType;
    this.questionDetails.configKey = this.selectedDataType.configKey;
    this.questionDetails.options = this.selectedDataType.options;
    this.questionDetails.options.forEach(o => o['isEditing'] = false);
  }*/

  onOkClicked(): boolean {
    const header = this.editQuestionForm.controls['questionHeader'].value;
    const title = this.editQuestionForm.controls['questionTitle'].value;
    const isRequired = this.editQuestionForm.controls['isRequired'].value;
    let dataType = this.editQuestionForm.controls['questionDataType'].value;
    if (dataType && dataType.split(',').length > 0) {
      dataType = dataType.split(',')[0];
    }
    const sectionId = this.editQuestionForm.controls['questionSection'].value;
    this.selectedSection = this.sections.find(section => section.sectionId === sectionId);
    if (!this.editQuestionForm.valid) {
      this.snackBarService.showError('Please fill up necessary fields.');
      return false;
    }
    if (this.editQuestionForm.controls['questionHeader'].value.trim() === '') {
      this.snackBarService.showError('Header cannot be empty.');
      return false;
    }
    this.data.input.editFieldQuestionDetails.questionDetails.header = header;
    this.data.input.editFieldQuestionDetails.questionDetails.instruction = title;
    this.data.input.editFieldQuestionDetails.questionDetails.isMandatory = isRequired;
    this.data.input.editFieldQuestionDetails.questionDetails.options = this.questionDetails.options;
    this.data.input.editFieldQuestionDetails.questionDetails.dataType = dataType;
    this.data.input.editFieldQuestionDetails.selectedSection = this.selectedSection;

    return true;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private populateForm() {
    if (this.questionDetails) {
      if (!this.questionDetails.hasOwnProperty('header')) {
        this.questionDetails.header = '';
      }
      if (!this.questionDetails.hasOwnProperty('instruction')) {
        this.questionDetails.instruction = '';
      }
      if (!this.questionDetails.hasOwnProperty('isMandatory')) {
        this.questionDetails.isMandatory = true;
      }
      this.editQuestionForm.patchValue({['questionHeader']: this.questionDetails.header});
      this.editQuestionForm.patchValue({['questionTitle']: this.questionDetails.instruction});
      if (!this.editQuestionForm.controls['questionTitle'].value) {
        this.editQuestionForm.patchValue({['questionTitle']: this.questionDetails.header});
      }
      let configKey = this.questionDetails.configKey;
      if (configKey === undefined || configKey === null) {
        configKey = '';
      }
      let dataType = this.questionDetails.dataType;
      if(dataType === undefined || dataType === null) {
        dataType = '';
      }

      if (dataType.length || configKey.length) {
        const uniqueIdentifier = `${dataType},${configKey}`;
        this.editQuestionForm.patchValue({['questionDataType']: uniqueIdentifier});
      }
      this.editQuestionForm.patchValue({['isRequired']: this.questionDetails.isMandatory === undefined ? true : this.questionDetails.isMandatory});
      this.fieldSettings = null;
      if (this.questionDetails.configKey) {
        const fieldConfig = Configuration.getSmartGridConfig(this.questionDetails.configKey);
        if (fieldConfig && fieldConfig.FieldSettings) {
          this.fieldSettings = fieldConfig.FieldSettings;
        }
      }
    }
    if (this.selectedSection) {
      this.editQuestionForm.patchValue({['questionSection']: this.selectedSection.sectionId});
    }
  }
}
